
import commonApi from '@/api/common';
import { defineComponent } from 'vue';
import { message as $message } from 'ant-design-vue';
import environment from '@/untils/environment';
import moment from 'moment';

export default defineComponent({
  name: 'PayResult',
  components: {
  },
  data() {
    const lists: Array<object> = [];
    return {
      time: '',
      list: lists,
      type: -1,
    };
  },
  setup() {
    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };
    return {
      error,
      success,
    };
  },
  mounted() {
    this.getShopInfo();
    this.getDataConfForSaas();
  },
  methods: {
    backToShop() {
      const accountId = localStorage.getItem('accountId');
      const memberId = localStorage.getItem('memberId');
      const token = localStorage.getItem('token');
      const siteId = localStorage.getItem('siteId');
      const loc = window.location;
      const uri = loc.host;
      const url = `http://${uri.indexOf('pre') === -1 ? 'hdsupport.saas.seatent.com' : 'hdsupport.saas.saaspre.seatent.com'}/#/callback?randomCode=42rfmhh9x73juwvw&approach=22&token=${token}&accountId=${accountId}&appkey=${environment.appkey}&siteId=${siteId}&memberId=${memberId}&link=/home/go`;
      console.log(url);
      window.location.href = url;
    },
    getShopInfo() {
      interface Data{
        data: Shopinfo;
        success: boolean;
        message: string;
      }
      interface Shopinfo{
        versionEndTime: number;
        versionType: number;
      }
      commonApi.getShopInfo({}).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          this.time = moment(data.versionEndTime).format('YYYY-MM-DD');
          this.type = data.versionType;
        } else {
          console.log(message);
          this.error(message);
        }
      });
    },
    getDataConfForSaas() {
      interface Data{
        data: [];
        success: boolean;
        message: string;
      }
      commonApi.getDataConfForSaas({ })
        .then(async ({ data, success, message }: Data) => {
          if (success) {
            console.log(data);
            interface SData{
              createAccount: string;
              id: number;
              key: string;
              name: string;
              remark: string;
              sort: number;
              type: string;
              typeName: string;
              updateAccount: string;
              value: string;
            }
            data.forEach((element: SData) => {
              this.list.push(element);
            });
          } else {
            this.error(message);
            console.log(message);
          }
        });
    },
  },
});
